import React, {useEffect, useState} from 'react';
import './onboard-question-style.scss';
import {useTranslation} from "react-i18next";

const QuestionSelectComponent = (props) => {
    const {t} = useTranslation();
    const {select, options, error, value} = props;
    const [selectOption, setSelectOption] = useState(value || null);
    const [mError, setMError] = useState(false);

    const renderStar = () => {
        return options?.map((option, index) => {
            return <p key={index}
                      onClick={() => handleSelect(option, index)}
                      className={"cursor question-select-option " + (selectOption === index ? 'question-select-option-select' : '')}>{option.text}</p>
        });
    }

    useEffect(() => {
        if (error === true && selectOption === null) {
            setMError(true);
        }
    }, [error])

    useEffect(() => {
        let status = false;
        options.forEach((opt, index) => {
            if (opt.id == value) {
                handleSelect(opt, index)
                status = true;
            }
        });
        if (!status) handleSelect(100, null)
    }, [value])

    const handleSelect = (option, index) => {
        setSelectOption(index);
        select(option);
        setMError(false);
    }

    return (
        <div>
            {mError && <p className="question-error">{t('feedback.error_empty')}</p>}
            <div className="question-select-root">
                {renderStar()}
            </div>
        </div>
    )
};

export default QuestionSelectComponent;
